import * as React from "react"
import PropTypes from "prop-types"
import Seo from "components/Seo"
import { Global, ThemeProvider } from "@emotion/react"
import theme from "theme"
import modernNormalize from "styles/modernNormalize"
import reboot from "styles/reboot"
import fontGilroy from "styles/fontGilroy"
import fontGothamPro from "styles/fontGothamPro"
import CookieConsent from "components/CookieConsent"
import * as Sections from "sections"
import { load } from "recaptcha-v3"

import "swiper/css"
import "swiper/css/navigation"

const Template = ({ pageContext: { baseUrl, sections, cookieConsent, recaptchaKey } }) => {
  const [recaptcha, setRecaptcha] = React.useState(null)
  const [cookie, setCookie] = React.useState(false)
  const [cookieAccept, setCookieAccept] = React.useState(false)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const scriptId = "hs-script-loader"
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script")
        script.src = `//js.hs-scripts.com/4128655.js`
        script.async = true
        script.defer = true
        script.id = scriptId
        document.head.appendChild(script)
      }
    }
  }, [])

  const cookieCheck = () =>
    typeof window !== "undefined" &&
    document.cookie
      .split(";")
      .map((el) => (el.trim() === "adexin-google-analytics=true" ? setCookieAccept(true) : el))

  React.useEffect(() => {
    cookieCheck()
  }, [cookie])

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const asyncFunction = async () => {
        setRecaptcha(
          await load(recaptchaKey, {
            useRecaptchaNet: true,
            autoHideBadge: true,
          }),
        )
      }

      setTimeout(asyncFunction, 3500)
    }
  }, [recaptchaKey])

  React.useEffect(() => {
    if (cookieAccept) {
      const date = new Date(Date.now() + 7.863e9).toUTCString()
      const sourceSite = document.referrer || "direct"

      if (sourceSite !== "direct" || !`${document.cookie}`.match(/sourceRefer=\S+/)) {
        document.cookie = `sourceRefer=${sourceSite}; path=/; expires=${date}`
        console.log("SourceRefer Cookie Set:", document.cookie)
      }

      const urlParams = new URLSearchParams(window.location.search)

      const utmMark = {
        utm_source: urlParams.get("utm_source") || "",
        utm_medium: urlParams.get("utm_medium") || "",
        utm_campaign: urlParams.get("utm_campaign") || "",
      }

      if (utmMark.utm_source || utmMark.utm_medium || utmMark.utm_campaign) {
        if (utmMark.utm_source) {
          document.cookie = `utmSource=${utmMark.utm_source}; path=/; expires=${date}`
        }
        if (utmMark.utm_medium) {
          document.cookie = `utmMedium=${utmMark.utm_medium}; path=/; expires=${date}`
        }
        if (utmMark.utm_campaign) {
          document.cookie = `utmCampaign=${utmMark.utm_campaign}; path=/; expires=${date}`
        }
      }

      sessionStorage.setItem("ActiveSeccion", true)
    }
  }, [cookieAccept])

  return (
    <ThemeProvider theme={theme}>
      <Global styles={[modernNormalize, reboot, fontGilroy, fontGothamPro]} />
      <CookieConsent setCookie={setCookie} {...cookieConsent} />
      <div>
        {sections.map(({ id, component, ...props }) => {
          const Component = Sections[component]
          if (!Component) return null
          return (
            <Component
              cookie={cookie}
              key={id}
              baseUrl={baseUrl}
              recaptcha={recaptcha}
              {...props}
            />
          )
        })}
      </div>
    </ThemeProvider>
  )
}

export const Head = ({ pageContext: { seo } }) => <Seo {...seo} />

Template.propTypes = {
  pageContext: PropTypes.exact({
    baseUrl: PropTypes.string,
    seo: PropTypes.object,
    cookieConsent: PropTypes.object,
    recaptchaKey: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        component: PropTypes.string,
      }),
    ),
  }).isRequired,
}

Head.propTypes = {
  pageContext: PropTypes.shape({
    seo: PropTypes.object.isRequired,
  }).isRequired,
}

export default Template
